import { AppState } from "../../../store";
//Selectors that pull values from state.
export const getRules = (state: AppState) => state.reducer.Rules.data;